import React, { Component } from 'react';
import './App.css';
import withRequisitionStep from './components/withRequisitionStep';
import withWorkflow from './components/withWorkflow';
import { scrollToMessage } from './util/scrollToMessage';
import { isGovernmentPayorOrder } from './util/gearOrderUtil';
import MedicareOrderAlert from './components/MedicareOrderAlert';
import SampleCollectionForm from './sample-collection/SampleCollectionForm';
import AddAnotherTest from './confirm/AddAnotherTest';

/**
 * Component for the 'collection' step of the GEAR order workflow.
 */
class SampleCollectionInfo extends Component {
	constructor(props) {
		super(props);

		this.formRef = React.createRef();

		this.handleSubmit = this.handleSubmit.bind(this);
		this.goBack = this.goBack.bind(this);
		this.startNewRequisition = this.startNewRequisition.bind(this);
	}

	goBack(e) {
		if (this.props.doConfirm(e)) {
			this.props.updateStep(this.props.gearOrder, 'collection', 'Back', this.props.activeGearRequisitionId);
		} else {
			e.preventDefault();
		}
	}
	handleSubmit(e) {
		e.preventDefault();
		this.save();
	}
	startNewRequisition(e) {
		e.preventDefault();
		this.save(true);
	}

	save(startNewRequisition) {
		this.props.setLoading(true);
		this.formRef.current
			.save()
			.then((gearOrder) => {
				if (gearOrder?.id) {
					this.props.setGearOrder(gearOrder);
					this.props.setDirty(false);

					if (startNewRequisition === true) {
						this.props.setAddNewReq(true);
						this.props.setOmsRequisition(null);
						this.props.updateStep(gearOrder, 'panel');
					} else {
						this.props.updateStep(gearOrder, 'collection', 'Next', this.props.activeGearRequisitionId);
					}
				} else {
					this.props.showError('Please try again or call us at 800-522-4762 if the issue continues.');
				}
			})
			.catch((error) => {
				if (error === 'ValidationError') {
					scrollToMessage();
				} else {
					this.props.showError(error.message);
					console.log('Sample Collection PUT request failed', error);
				}
			})
			.finally(() => {
				this.props.setLoading(false);
			});
	}

	render() {
		// Is this order for a Government payor (Medicare/Tricare)
		const isGovernmentOrder = isGovernmentPayorOrder(this.props.gearOrder);

		return (
			<div>
				<h2>
					Sample Collection Information
					<br />
					<small>{this.props.getRequisitionTitle(this.props.omsRequisition)}</small>
				</h2>
				{isGovernmentOrder && this.props.userInfo.type === 'myGDX' && <MedicareOrderAlert />}
				<SampleCollectionForm
					ref={this.formRef}
					gearRequisition={this.props.activeGearRequisition}
					omsRequisition={this.props.omsRequisition}
					gearOrder={this.props.gearOrder}
					userType={this.props.userInfo.type}
				/>
				<div className="row">
					<div className="col-md-12 sticky-bottom btn-toolbar">
						<button
							type="button"
							className="btn btn-white radius btn-sm margin-clear"
							onClick={this.goBack}
						>
							<i className="pl-10 fa fa-arrow-circle-left"></i> &nbsp; Back
						</button>
						<button
							type="submit"
							className="btn btn-primary radius btn-sm margin-clear pull-right"
							onClick={this.handleSubmit}
						>
							Next
							<i className="pl-10 fa fa-arrow-circle-right"></i>
						</button>
						{!this.props.inlineMode && (
							<AddAnotherTest
								gearOrder={this.props.gearOrder}
								userInfo={this.props.userInfo}
								buttonEl={
									<button
										type="button"
										className="btn btn-add-test radius btn-sm margin-clear pull-right"
										onClick={this.startNewRequisition}
									>
										<i className="pl-10 fa fa-plus"></i> &nbsp; Add Another Test
									</button>
								}
							/>
						)}
					</div>
				</div>
			</div>
		);
	}
}

// wrap the component in the workflow and requisition step HOCs to get access to common logic
export default withWorkflow(withRequisitionStep(SampleCollectionInfo));
